// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".satisfaction-box {\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 0.2rem;\n  border: 0.1rem solid #BFCBD1;\n}\n.green {\n  background-color: #00C853;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
